// Unicode to ISM (DVBW_YogeshEN) Converter
// Based on the original Unicode_to_DVBW_YogeshEN function

export function convert_unicode_to_ism(speechdata) {

    var array_one = new Array(
        "कृ", "के", "ङे", "छे", "टे", "ठे", "डे", "ढे", "दे", "रे", "ळे", "हे",
        "क़्", "ख़्", "ग़्", "ज़्", "फ़्", "क़", "ख़", "ग़", "ज़", "फ़", "ड़", "ढ़", // two-byte varnas

        "ॐ", "ऽ", "ः", "।", "् ", "फ़्र", "ऑ", "ॉ", "क्ष्", "क्ष", "त्र्", "त्र", "ज्ञ्", "ज्ञ", "श्र्", "श्र", "द्ध", "द्य",

        "ओं", "औं", "ओ", "औ", "आ", "अ", "ई", "इ", "ऊ", "उ", "ऋ", "ऐ", "ए",

        "क्र", "ट्र", "ड्र", "ढ्र", "्र",

        "क़्", "क्", "क़", "क", "ख़्", "ख्", "ग़्", "ग्", "ग्र्", "घ्", "ङ",
        "ख़", "ख", "ग़", "ग", "ग्र", "घ",

        "च्", "छ", "ज़्", "ज्", "झ्", "ञ्",
        "च", "ज़", "ज", "झ", "ञ",

        "ट", "ठ", "ड", "ढ", "ण्", "ण", "ड़", "ढ़",

        "त्त्", "त्त", "त्", "थ्", "द", "दृ", "द्र", "द्द", "द्म", "द्व", "न्", "ध्",
        "त", "थ", "न", "ध",

        "प्", "फ़्", "फ़", "फ्", "फ", "ब्", "भ्", "म्",
        "प", "ब", "भ", "म",

        "य्", "रु", "रू", "र", "ल्", "ळ्", "ळ", "व्",
        "य", "ल", "व",

        "श्", "ष्", "स्",
        "श", "ष", "स",

        "ट्ट", "ट्ठ",

        "ह्", "ह", "हृ", "ह्र", "ह्म", "ह्य", "्य",

        "॰", "्", "़", "़", "ँ", "ं",

        "ट्ठ", "ड्ड", "ड्ढ",

        "ो", "ौ", "े", "ै", "ा", "ी", "ु", "ू", "ृ", "ें", "ैं", "ॅ");

    var array_two = new Array(

        "Ûéú", "Ûêú", "’êû", "”êû", "™êü", "šêü", "›êü", "œêü", "¤êü", "¸êü", "ôêû", "Æêü",
        "क़्", "ख़्", "ग़्", "ज़्", "फ़्", "क़", "ख़", "ग़", "ज़", "फ़", "ड़", "ढ़", // one-byte varnas

        "‚", "ƒ", "„", "…", "Ë ", "±ÏÌ", "†Öò", "Öò", "õ", "õÖ", "¡", "¡Ö", "–", "–Ö", "Á", "ÁÖ", "¨", "ª",

        "†ÖêÓ", "†ÖîÓ", "†Öê", "†Öî", "†Ö", "†", "‡Ô", "‡", "‰ú", "ˆ", "Š", "‹ê", "‹",

        "Îú", "™Ò", "›Ò", "œÒ", "Î",

        "ŒÌ", "Œ", "Ìú", "Ûú", "Ì", "Ü", "Ì", "Ý", "Î", "‘", "’û", // "Îú","Ðú","Ï"
        "ÌÖ", "ÜÖ", "ÌÖ", "ÝÖ", "ÎÖ", "‘Ö",

        "“", "”û", "•Ì", "•", "—", "˜",
        "“Ö", "•ÌÖ", "•Ö", "—Ö", "˜Ö",

        "™ü", "šü", "›ü", "œü", "Þ", "ÞÖ", "›Í", "œÍ",

        "¢", "¢Ö", "Ÿ", "£", "¤ü", "¥", "¦", "§", "©", "«", "®", "¬",
        "ŸÖ", "£Ö", "®Ö", "¬Ö",

        "¯", "°Ì", "±Ìú", "°", "±ú", "²", "³", "´",
        "¯Ö", "²Ö", "³Ö", "´Ö",

        "µ", "¹ú", "ºþ", "¸ü", "»", "ó", "ôû", "¾",
        "µÖ", "»Ö", "¾Ö",

        "¿", "Â", "Ã",
        "¿Ö", "ÂÖ", "ÃÖ",


        "¼", "½",

        "Å", "Æü", "Ç", "È", "É", "Ê", "•",

        ".", "Ë", "Ì", "Í", "Ñ", "Ó", //"Ï","Ð","Ò",

        "÷", "ø", "ù",

        "Öê", "Öî", "ê", "î", "Ö", "ß", "ã", "æ", "é", "ë", "ï", "ò");

    var array_one_length = array_one.length;
    var modified_substring = speechdata;

    function Replace_Symbols() {
        if (modified_substring != "") {
            modified_substring = modified_substring.replace(/क़/g, "क़");
            modified_substring = modified_substring.replace(/ख़‌/g, "ख़");
            modified_substring = modified_substring.replace(/ग़/g, "ग़");
            modified_substring = modified_substring.replace(/ज़/g, "ज़");
            modified_substring = modified_substring.replace(/ड़/g, "ड़");
            modified_substring = modified_substring.replace(/ढ़/g, "ढ़");
            modified_substring = modified_substring.replace(/ऩ/g, "ऩ");
            modified_substring = modified_substring.replace(/फ़/g, "फ़");
            modified_substring = modified_substring.replace(/य़/g, "य़");
            modified_substring = modified_substring.replace(/ऱ/g, "ऱ");

            var position_of_f = modified_substring.indexOf("ि");
            while (position_of_f != -1) {
                var character_left_to_f = modified_substring.charAt(position_of_f - 1);
                modified_substring = modified_substring.replace(character_left_to_f + "ि", "×" + character_left_to_f);
                position_of_f = position_of_f - 1;
                while ((modified_substring.charAt(position_of_f - 1) == "्") & (position_of_f != 0)) {
                    var string_to_be_replaced = modified_substring.charAt(position_of_f - 2) + "्";
                    modified_substring = modified_substring.replace(string_to_be_replaced + "×", "×" + string_to_be_replaced);
                    position_of_f = position_of_f - 2;
                }
                position_of_f = modified_substring.search(/ि/, position_of_f + 1);
            }

            let set_of_matras = "ािीुूृेैोौं:ँॅ";
            modified_substring += '  ';

            var position_of_half_R = modified_substring.indexOf("र्");
            while (position_of_half_R > 0) {
                var probable_position_of_Z = position_of_half_R + 2;
                var character_right_to_probable_position_of_Z = modified_substring.charAt(probable_position_of_Z + 1)
                while (set_of_matras.indexOf(character_right_to_probable_position_of_Z) != -1) {
                    probable_position_of_Z = probable_position_of_Z + 1;
                    character_right_to_probable_position_of_Z = modified_substring.charAt(probable_position_of_Z + 1);
                }
                let string_to_be_replaced = modified_substring.substr(position_of_half_R + 2, (probable_position_of_Z - position_of_half_R - 1));
                modified_substring = modified_substring.replace("र्" + string_to_be_replaced, string_to_be_replaced + "Ô");
                position_of_half_R = modified_substring.indexOf("र्");
            }
            modified_substring = modified_substring.substr(0, modified_substring.length - 2);

            for (let input_symbol_idx = 0; input_symbol_idx < array_one_length; input_symbol_idx++) {
                let idx = 0;
                while (idx != -1) {
                    modified_substring = modified_substring.replace(array_one[input_symbol_idx], array_two[input_symbol_idx])
                    idx = modified_substring.indexOf(array_one[input_symbol_idx])
                }
            }
        }
    }

    var text_size = speechdata.length;
    var processed_text = '';
    var sthiti1 = 0;
    var sthiti2 = 0;
    var chale_chalo = 1;
    var max_text_size = 10000;

    while (chale_chalo == 1) {
        sthiti1 = sthiti2;
        if (sthiti2 < (text_size - max_text_size)) {
            sthiti2 += max_text_size;
            while (speechdata.charAt(sthiti2) != ' ') {
                sthiti2--;
            }
        } else {
            sthiti2 = text_size;
            chale_chalo = 0
        }
        modified_substring = speechdata.substring(sthiti1, sthiti2);
        Replace_Symbols();
        processed_text += modified_substring;
    }

    return processed_text;
}
